module.exports = __webpack_public_path__ + "static/media/492OliverStNW_2018-07-09_142.42a2ef42.jpg";